import {TeacherUpdateClassroomForm} from './TeacherUpdateClassroomForm';

export default TeacherUpdateClassroomForm;
